import { ExpectedPriceRangeBar } from "@/components/ExpectedPriceRangeBar";

/**
 * 공통 견적 LP 비용 가이드
 * - 전체 범위(38~1,205만원) 안에서 평균 가족장~일반장(427~826) 강조
 * - 평균치 출처: parlors_detail.json 통계 (1,026개 parlor 기준)
 */

const NATIONAL_MIN_PRICE = 38;
const NATIONAL_MAX_PRICE = 1205;
const AVG_FAMILY_COST = 427;
const AVG_GENERAL_COST = 826;

export const CommonQuoteCostGuide = () => {
  return (
    <section className="lp-cost-wrap">
      <ExpectedPriceRangeBar
        min={AVG_FAMILY_COST}
        max={AVG_GENERAL_COST}
        MIN_PRICE={NATIONAL_MIN_PRICE}
        MAX_PRICE={NATIONAL_MAX_PRICE}
      />
    </section>
  );
};
